import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import PrimaryButton from "../../../Forms/PrimaryButton";
import TextField from "../../../Forms/TextField";
import FeatureSummary from "../../../Util/FeatureSummary";

const MemberEmailUnsubscribe = () => {
    const [email, setEmail] = useState("");
    const history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email.trim()) {
            history.push(`member-email-unsubscribe/${encodeURIComponent(email.trim())}`);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div style={{ marginTop: 30 }}>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="Email Address"
                />
            </div>
            
            <PrimaryButton text="Next" type="submit" disabled={!email.trim()} style={{ marginTop: 16 }} />
            <FeatureSummary
                label="About Email Unsubscribe"
                summary="Unsubscribe a member from email communications. Enter the member's email address to proceed to the unsubscribe options."
            />
        </form>
    );
};

export default MemberEmailUnsubscribe;